// SEOHead — per-page title, description, OG tags, canonical, structured data.
// Drop into any page like:
//   <SEOHead title="Bank PO Career" description="..." path="/explore/careers-ts-ap/banking/po"/>
//
// Falls back to sensible defaults for the site.

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'LearnixTa';
const SITE_URL = 'https://learnixta.com';
const DEFAULT_TITLE = 'LearnixTa — Honest Career Clarity';
const DEFAULT_DESC = 'Honest Career Clarity';

export default function SEOHead({
  title,
  description,
  path = '',
  image,
  structuredData,
  type = 'website',
  noIndex = false,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;
  const canonical = `${SITE_URL}${path || ''}`;
  const ogImage = image || null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      {ogImage && <meta property="og:image" content={ogImage} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* JSON-LD structured data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
}
